import { React } from '../../utils/globalImports';
import Link from '@mui/material/Link';
import './Footer.css';


const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  const version = "1.0.0";
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-icon">

        </div>
        <p>
          © {currentYear}{' '} - Version {version} {' '} | {' '}
          <Link color="inherit" href="https://rsk-bsl.com/" underline="none" target="_blank" >
            RSK Business Solutions . All rights reserved.
          </Link>
        </p>
      </div>
    </footer>
  );
}

export default Footer;
